import React, { Component } from "react";
import { connect } from "react-redux";
import {
    setPlaying,
    setPosition,
    setDragging,
    selectPlaying,
    selectDuration,
    selectCurrentTimestamp,
    selectDragging,
} from "../../ducks/time";
import { timestampFine, timestampMeridiem } from "../../modules/format";
import getMouseOffsetPosition from "../../modules/get-mouse-offset-position";

import Styles from "./time-plot-overlay.module.scss";

// Distance from bottom of overlay to bottom of timeline
const LINE_BOTTOM_OFFSET = 12;
const TIMESTAMP_RECT_WIDTH = 90;
const TIMESTAMP_RECT_HEIGHT = 28;
const TIMESTAMP_TRI_SIZE = 10;
const LINE_TRI_WIDTH = 18;
const LEGEND_WIDTH = 150 + 40;

class TimePlotOverlay extends Component {

    constructor(props) {
        super(props);
        this.state = {
            height: null,
            width: null,
        }
        this.handleVisMouseDown = this.handleVisMouseDown.bind(this);
        this.handleVisMouseUp = this.handleVisMouseUp.bind(this);
        this.handleVisMouseMove = this.handleVisMouseMove.bind(this);
        this.handleAnimationFrame = this.handleAnimationFrame.bind(this);

        this.animationFrame = window.requestAnimationFrame(this.handleAnimationFrame);
    }

    componentDidMount() {
        this.updateSvgHeight();
    }

    componentWillUnmount() {
        window.cancelAnimationFrame(this.animationFrame);
    }

    handleAnimationFrame() {
        this.updateSvgHeight();
        this.animationFrame = window.requestAnimationFrame(this.handleAnimationFrame);
    }

    updateSvgHeight() {
        const bbox = this.svg.getBoundingClientRect();
        const { height } = bbox;
        const width = bbox.width - LEGEND_WIDTH;
        if (width !== this.state.width || height !== this.state.height) {
            this.setState({
                height,
                width
            });
        }
    }

    setPositionFromMouseEvent(e) {
        const { duration, setPosition } = this.props;
        const offsetPosition = getMouseOffsetPosition(e);
        const percent = offsetPosition.x / (offsetPosition.rect.width - LEGEND_WIDTH);
        const newPosition = Math.min(percent * duration, duration);
        setPosition(newPosition);
    }

    handleVisMouseDown(e) {
        this.props.setDragging(true);
        this.setPositionFromMouseEvent(e);
    }

    handleVisMouseUp(e) {
        this.props.setDragging(false);
    }

    handleVisMouseMove(e) {
        if (this.props.dragging) {
            this.setPositionFromMouseEvent(e);
        }
    }

    renderContent() {
        const { width, height } = this.state;
        if (!width || !height) return null;
        const { playing, dragging, timeScale, currentTimestamp } = this.props;

        const currentX = (timeScale(currentTimestamp) / 100) * width

        const lineTop = 24;
        const lineBottom = height - LINE_BOTTOM_OFFSET;
        const lineTrianglePoints = `${currentX - LINE_TRI_WIDTH / 2},${lineTop} ${currentX + LINE_TRI_WIDTH / 2},${lineTop} ${currentX}, ${lineTop + 15}`

        // TODO: flip flop depending on side
        const timestampY = lineBottom - 30;
        const timestampRectLeft = currentX + TIMESTAMP_TRI_SIZE;
        const timestampLeftX = timestampRectLeft + (TIMESTAMP_RECT_WIDTH / 2);
        const timestampRectTop = timestampY - (TIMESTAMP_RECT_HEIGHT / 2);

        const timestampTriangleTop = timestampY - (TIMESTAMP_TRI_SIZE / 2);
        const timestampTriangleBottom = timestampY + (TIMESTAMP_TRI_SIZE / 2);

        const timestmapTrianglePoints = `${currentX + 2}, ${timestampY} ${timestampRectLeft + 1},${timestampTriangleTop} ${timestampRectLeft + 1},${timestampTriangleBottom}`

        return (
            <React.Fragment>
                <g>
                    <polygon className={Styles.currentPositionTriangle} points={lineTrianglePoints}/>
                    <line
                        className={Styles.currentPositionLine}
                        x1={currentX}
                        x2={currentX}
                        y1={lineTop}
                        y2={lineBottom}
                    />
                </g>
                <g className={Styles.currentTimeGroup} data-visible={playing || dragging || true}>
                    <polygon className={Styles.currentTimeTriangle} points={timestmapTrianglePoints}/>
                    <rect className={Styles.currentTimeRect} x={timestampRectLeft} width={TIMESTAMP_RECT_WIDTH} y={timestampRectTop} height={TIMESTAMP_RECT_HEIGHT} />
                    <text className={Styles.currentTimeText} x={timestampLeftX} y={timestampY}>
                        <tspan>{timestampFine(currentTimestamp)}</tspan>
                        <tspan dx={3} className={Styles.currentTimeMinor}>{timestampMeridiem(currentTimestamp)}</tspan>
                    </text>
                </g>
            </React.Fragment>
        )
    }

    render() {
        return (
            <div className={Styles.timePlotOverlay}>
                <svg
                    className={Styles.svg}
                    ref={r => this.svg = r}
                    onMouseDown={this.handleVisMouseDown}
                    onTouchStart={this.handleVisMouseDown}
                    onMouseUp={this.handleVisMouseUp}
                    onTouchEnd={this.handleVisMouseUp}
                    onMouseMove={this.handleVisMouseMove}
                    onTouchMove={this.handleVisMouseMove}
                >
                    {this.renderContent()}
                </svg>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        playing: selectPlaying(state),
        duration: selectDuration(state),
        dragging: selectDragging(state),
        currentTimestamp: selectCurrentTimestamp(state, props.video),
    };
};
const mapDispatchToProps = {
    setPlaying,
    setPosition,
    setDragging,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TimePlotOverlay);



// WEBPACK FOOTER //
// ./src/components/time-plot-overlay/time-plot-overlay.js